/**
 * CRA only exposes REACT_APP_* vars baked in at `npm start` / `npm run build`.
 * Restart the dev server after changing .env.
 *
 * Empty REACT_APP_API_URL → relative /api (dev: setupProxy, Docker: nginx proxy).
 */
export function getApiBaseUrl() {
  const raw = process.env.REACT_APP_API_URL;
  if (typeof raw !== 'string' || !raw.trim()) {
    return '';
  }

  if (process.env.NODE_ENV === 'development') {
    return '';
  }

  return raw.trim().replace(/\/$/, '');
}
